module.exports = __webpack_public_path__ + "media/images/spinner-horizontal-waves-57bd8c2cca74f296967da1037e8ed629.gif";